export default "__VITE_ASSET__Cn8zW2Pf__"